/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

import { Directive, Input } from '@angular/core';

@Directive({
	selector: '[automationId]',
	standalone: true,
})
export class AutomationIdDirective {
	@Input() automationId: string = '';
}
